import React from 'react';
import Axios from 'axios';
//import { Tooltip } from 'reactstrap';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter, 
  Collapse,
  Tooltip
} from 'reactstrap';

import moment from 'moment';
import * as predatorStandings from './predatorStandings.js';

const cstTableHeaders_reg = [
	['Rg', 'Joueur', 'Pts'],
	['Rg', 'Joueur', 'Pos', 'Pts']
];
const cstDefaultSortOrder_reg = [
	['', 'asc', 'desc'],
	['', 'asc', 'asc', 'desc']
];

const cstTableHeaders_dc = [
	['Rg', 'Joueur', 'Pts', 'Boni', 'Total'],
	['Rg', 'Joueur', 'Pos', 'Pts', 'Boni', 'Total'],
];
const cstDefaultSortOrder_dc = [
	['', 'asc', 'desc', 'desc', 'desc'],
	['', 'asc', 'asc', 'desc', 'desc', 'desc']
];
/*
const cstFixedDecimals = [
	{header: 'Pts', decimals: 0}
];
*/
const cstDefaultSortFieldIdx_reg = [2, 3];
const cstDefaultSortFieldIdx_dc = [4, 5];


class PredatorTour extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			selectedStandings: "Cumulatif",

			tableDataA: [],
			sortFieldIdxA: cstDefaultSortFieldIdx_reg[0],
			sortOrderA: cstDefaultSortOrder_reg[0][cstDefaultSortFieldIdx_reg[0]],

			tableDataB: [],
			sortFieldIdxB: cstDefaultSortFieldIdx_dc[0],
			sortOrderB: cstDefaultSortOrder_dc[0][cstDefaultSortFieldIdx_dc[0]],

			loading: true,
		};

    this.createHdrRow = this.createHdrRow.bind(this);
    this.handleSortTable = this.handleSortTable.bind(this);
    this.createTableRow = this.createTableRow.bind(this);
    this.handleSelectedStandingsChange = this.handleSelectedStandingsChange.bind(this);
	}

	componentDidMount() {
		// console.log('PredatorTour: componentDidMount');
		this.buildTableData(this.state.selectedStandings);
	}

	UNSAFE_componentWillReceiveProps() {
		// console.log('PredatorTour: UNSAFE_componentWillReceiveProps');
	}

	buildTableData(selectedStandings) {

		var tableDataA = [];
		var tableDataB = [];

		var standingsTypes = predatorStandings.standingsTypes;
		var selectedStandingsIdx = 0;
		for (var pstIdx = 0; pstIdx < standingsTypes.length; pstIdx++) {
			if (standingsTypes[pstIdx] === selectedStandings) {
				selectedStandingsIdx = pstIdx;
			}
		}

		predatorStandings.standings_reg[selectedStandingsIdx].forEach((dataRow, dataRowIdx) => {
			var tableDataRow = [];
			tableDataRow.push(0);	// rank
			tableDataRow.push(dataRow[0]);
			tableDataRow.push(dataRow[1]);
			if (selectedStandingsIdx !== 0) {
				tableDataRow.push(dataRow[2]);				
			}
			tableDataA.push(tableDataRow);
		});

		predatorStandings.standings_2ndCh[selectedStandingsIdx].forEach((dataRow, dataRowIdx) => {

			var tableDataRow = [];
			tableDataRow.push(0);	// rank
			tableDataRow.push(dataRow[0]);
			tableDataRow.push(dataRow[1]);
			tableDataRow.push(dataRow[2]);
			tableDataRow.push(dataRow[3]);
			if (selectedStandingsIdx !== 0) {
				tableDataRow.push(dataRow[4]);
			}

			tableDataB.push(tableDataRow);
		});


		// reset sort
		var sortFieldIdxA = cstDefaultSortFieldIdx_reg[0];
		var sortOrderA = cstDefaultSortOrder_reg[0][sortFieldIdxA];
		if (selectedStandings !== "Cumulatif") {
			sortFieldIdxA = cstDefaultSortFieldIdx_reg[1];
			sortOrderA = cstDefaultSortOrder_reg[1][sortFieldIdxA];
		}

		var sortFieldIdxB = cstDefaultSortFieldIdx_dc[0];
		var sortOrderB = cstDefaultSortOrder_dc[0][sortFieldIdxB];
		if (selectedStandings !== "Cumulatif") {
			sortFieldIdxB = cstDefaultSortFieldIdx_dc[1];
			sortOrderB = cstDefaultSortOrder_dc[1][sortFieldIdxB];
		}

		this.sortTable(tableDataA, sortFieldIdxA, sortOrderA, 0);
		this.sortTable(tableDataB, sortFieldIdxB, sortOrderB, 1);
	}

	sortTable(tableData, sortFieldIdx, sortOrder, standIdx) {

		// console.log('Sorting: ', standIdx, sortFieldIdx, sortOrder)
		var _this = this;
		var sortSign = 1;
		if (sortOrder === 'desc') { 
			sortSign = -1; 
		}

		// Sort data
		tableData.sort(function (a, b) {

			var valueA = 0;
			var valueB = 0;
			var compVal = 0;

			var fact1 = 0;
			var fact2 = 0;
			var fact3 = 0;

			// Criteria #1
			valueA = a[sortFieldIdx];
			valueB = b[sortFieldIdx];

			if (typeof valueA === 'string') {
				if (valueA.substring(0, 2) === "Q-") {
					valueA = parseInt(valueA.substring(2), 10) + 10000;
				} else if (valueA.substring(0, 2) === "F-") {
					valueA = parseInt(valueA.substring(2), 10);
				}
			}
			if (typeof valueB === 'string') {
				if (valueB.substring(0, 2) === "Q-") {
					valueB = parseInt(valueB.substring(2), 10) + 10000;
				} else if (valueB.substring(0, 2) === "F-") {
					valueB = parseInt(valueB.substring(2), 10);
				}
			}

			switch(typeof valueA) {
		    case "date":
					compVal = new Date(valueA) - new Date(valueB);
	        break;

		    case "string":
		    	// test if string is numeric
		    	if(_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
						compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
		    	} else {
						compVal = valueA.localeCompare(valueB);
					}
  	      break;

		    case "number":
					compVal = valueA - valueB;
	        break;

		    default:
	        break;
			}

			fact1 = (sortSign * compVal);
			fact2 = (b[5] - a[5]);
			fact3 = (a[1].localeCompare(b[1]));

			// Results
			if (fact1 !== 0) {
				return fact1;
			} else if (fact2 !== 0) {
				return fact2;
			} else {
				return fact3;
			}
		});

		// Reset Rank column
		tableData.forEach(function(row, idx) {
			row[0] = idx + 1;
		});

		if (standIdx === 0) {
			_this.setState({
				tableDataA: tableData,
				sortFieldIdxA: sortFieldIdx,
				sortOrderA: sortOrder,
				loading: false
			});
		}
		if (standIdx === 1) {
			_this.setState({
				tableDataB: tableData,
				sortFieldIdxB: sortFieldIdx,
				sortOrderB: sortOrder,
				loading: false
			});
		}
	}

	render() {
		// console.log('Predator-Tour: render');
		// console.log(this.state.tableDataA);
		// console.log(this.state.tableDataB);
		
		var _this = this;
		return (
			<div className="animated fadeIn">

        <div className="row">
        <div className="col-12 text-center">
						<a href="https://predatorquebectour.com/" target="_blank">
							<img className="img-fluid" src="/img/predator-tour-01a.png" alt="pt-logo" width="1280"/>
							<br/><br/>	
						</a>
	      </div>
	      </div>

        <div className="row">
        <div className="col-12 text-center">
          <p>Le Predator Québec Pro-Am Tour est un circuit de billard professionnel, comprenant plus de 15 tournois 
          au Québec et en Ontario avec une équipe des plus expérimentée. Cette équipe est affiliée à la plus grande 
          marque de baguettes de billard au monde (Predator). Vous pourriez ainsi vous qualifier parmi nos 6 places 
          vous permettant ainsi de vous propulser à un tournoi d’envergure internationale, regroupant 128 joueurs 
          avec une somme de 50 000 USD ajoutés à la bourse , soit le "Predator Canada Open" à Toronto.
          </p>
        </div>
        </div>
        <hr/>

				<div className="row">
				<div className="col-md-12">
					{this.displayModule()}
					{this.displayExplanations()}
					{this.createLegend()}
					<i>STATELO - page en construction - plus de classements et de statistiques à venir</i>
				</div>
				</div>
				<br/><br/><br/>

      </div>
		);
	}

	displayModule() {
		if (this.state.loading) {
			return (this.displaySpinner());
		} else {
			return (this.displayData());
		}
	}

	displayData() {
		return (
			<div className="row">
			<div className="col-12">
	
				<div className="row row-margin-bottom-20 only-on-mobile">
	      <div className="col-md-4 col-12 text-center">
					{this.displayPredatorButtons()}
				</div>
				</div>

				<div className="row row-margin-bottom-20">
	      <div className="col-md-4 col-12">
					<h5>Classements des joueurs</h5>

					<span>Choisir un classement</span>
	  			<select className="form-control form-control-sm" type="text" id="pageSelect" value={this.state.selectedStandings}
	  				onChange={this.handleSelectedStandingsChange}>
	  				{predatorStandings.standingsTypes.map(this.predStandingsTypesOptions)}
					</select>
				</div>
				</div>

				<div className="row row-margin-bottom-20">
					{this.displayTnyReg()}
					{this.displayTny2ndchance()}
	
		      <div className="col-md-4 col-12 text-right not-on-mobile">
						{this.displayPredatorButtons()}
					</div>
	
				</div>
			</div>
			</div>
		);
	}

	predStandingsTypesOptions(opt, optIdx) {
		return (
    	<option key={'opt.' + optIdx}>{opt}</option>
		)
	}

	displayTnyReg() {
		var headers = cstTableHeaders_reg[0];
		if (this.state.selectedStandings !== "Cumulatif") {
			var headers = cstTableHeaders_reg[1];
		}

		return (
			<div className="col-md-4 col-12 row-margin-bottom-20">
				<h6>Tournois principaux</h6>

				<div className="table-responsive tableFixHeader">
				<table className="table table-hover table-sm">
				<thead>
					<tr>
						{headers.map(this.createHdrRow.bind(this, 0))}
					</tr>
				</thead>

				{this.displayTable(this.state.tableDataA, 0)}
				</table>
				</div>
			</div>
		);
	}

	displayTny2ndchance() {
		var headers = cstTableHeaders_dc[0];
		if (this.state.selectedStandings !== "Cumulatif") {
			var headers = cstTableHeaders_dc[1];
		}

		return (
			<div className="col-md-4 col-12 row-margin-bottom-20">
				<h6>Tournois 2e chance</h6>

				<div className="table-responsive tableFixHeader">
				<table className="table table-hover table-sm">
				<thead>
					<tr>
						{headers.map(this.createHdrRow.bind(this, 1))}
					</tr>
				</thead>

				{this.displayTable(this.state.tableDataB, 1)}
				</table>
				</div>
			</div>
		);
	}

	displayPredatorButtons() {
		return (
      <div className="row-margin-bottom-20">
				<a href="https://predatorquebectour.com/" target="_blank">
					<img className="img-fluid" src="/img/predator-tour-btn-01.png" alt="pred-tour-1" width="300"/>
				</a>
				<br/><br/>
				<a href="https://qvnea.com/playerpool/" target="_blank">
					<img className="img-fluid" src="/img/predator-tour-btn-02.png" alt="pred-tour-2" width="300"/>
				</a>
      </div>
		)
	}

	createHdrRow(standIdx, hdrItem, hdrIdx) {

		var classNameStr = '';
		var onClickAction = function() {};

		// Sort with arrows
		// No sort on Rank (column 0)
		if (hdrIdx !== 0) {
			onClickAction = this.handleSortTable.bind(this, standIdx);
			classNameStr = 'statelo-sorting';

			var sortFieldIdx = this.state.sortFieldIdxA;
			var sortOrder = this.state.sortOrderA;
			if (standIdx === 1) {
				sortFieldIdx = this.state.sortFieldIdxB;
				sortOrder = this.state.sortOrderB;
			}

			if(hdrIdx === sortFieldIdx) {
				if (sortOrder === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + hdrIdx} 
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

	displayTable(tableData, standIdx) {
		if (tableData.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucune statistique</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{tableData.map(this.createTableRow.bind(this, standIdx))}
				</tbody>
			)
		}
	}

  createTableRow(standIdx, row, rowIdx) {
    return (
      <tr key={'tablerow.' + rowIdx} id={'tablerow.' + rowIdx}>
        {row.map(this.dispCell.bind(this, standIdx, rowIdx))}
      </tr>
    );
  }

  dispCell(standIdx, rowIdx, cell, cellIdx) {

  	// all numbers rounded for now
  	if (typeof cell === "number") {
  		cell = Math.round(cell, 0);
  	}
  	
  	//console.log('dispCell', standIdx, rowIdx, cell, cellIdx);
    return (
     	<td key={"cell." + standIdx + "." + rowIdx + "." + cellIdx}> {cell} </td>
    );  	
  }

	handleSortTable(standIdx, e) {

		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		// standIdx === 0
		var sortOrder = this.state.sortOrderA;
		var prevSortFieldIdx = this.state.sortFieldIdxA;
		if (standIdx === 1) {
			sortOrder = this.state.sortOrderB;
			prevSortFieldIdx = this.state.sortFieldIdxB;
		}

		// console.log('handleSortTable: ', standIdx, sortFieldIdx, sortOrder)

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			if (standIdx === 0) {
				sortOrder = cstDefaultSortOrder_reg[0][sortFieldIdx];
				if (this.state.selectedStandings !== "Cumulatif") {
					sortOrder = cstDefaultSortOrder_reg[1][sortFieldIdx];
				}
			}
			if (standIdx === 1) {
				sortOrder = cstDefaultSortOrder_dc[0][sortFieldIdx];
				if (this.state.selectedStandings !== "Cumulatif") {
					sortOrder = cstDefaultSortOrder_dc[1][sortFieldIdx];
				}
			}
		}

		var sortFieldIdxA = this.state.sortFieldIdxA;
		var sortFieldIdxB = this.state.sortFieldIdxB;
		var sortOrderA = this.state.sortOrderA;
		var sortOrderB = this.state.sortOrderB;
		if (standIdx === 0) {
			sortFieldIdxA = sortFieldIdx;
			sortOrderA = sortOrder;
		}
		if (standIdx === 1) {
			sortFieldIdxB = sortFieldIdx;			
			sortOrderB = sortOrder;
		}

		if (standIdx === 0) {
			this.sortTable(this.state.tableDataA, sortFieldIdxA, sortOrderA, 0);
		}
		if (standIdx === 1) {
			this.sortTable(this.state.tableDataB, sortFieldIdxB, sortOrderB, 1);
		}
	}

	createLegend() {

		return (
			<div className="row">
			<div className="col-md-4 col-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
					
				<tbody>
				<tr key='leg1'>
					<td><b>Rg</b></td>
					<td>Rang</td>
				</tr>
				<tr key='leg2'>
					<td><b>Pos</b></td>
					<td>Position (F = Finale, Q = Qualif)</td>
				</tr>
				<tr key='leg3'>
					<td><b>Pts</b></td>
					<td>Points</td>
				</tr>
				</tbody>
				</table>
				</div>
				</div>
			</div>
			</div>
		);
	}

	displayExplanations () {
		return (
			<div className="row row-margin-bottom-20">
			<div className="col-12">
	
				<h6>Points aux classements - Tournois Principaux</h6>
				<ul className="ul-left-aligned">
					<li>La dernière position dans le tournoi a 3 points.  Chaque position suivante en montant, on ajoute un 
						point, et ainsi de suite jusqu'à la première position.</li>
					<li>Lorsqu'il y a un ou des tournois de qualifications, les positions se suivent entre le tableau de 
						qualifications et le tableau final</li>
					<li>Donc plus il y a de participants dans un tournoi, plus la première position aura de points</li>
				</ul>

				<h6>Points aux classements - Tournois 2e chance</h6>
				<ul className="ul-left-aligned">
					<li>La dernière position dans le tournoi a 3 points.  Chaque position suivante en montant, on ajoute un 
						point, et ainsi de suite jusqu'à la première position.</li>
					<li>Donc plus il y a de participants dans un tournoi, plus la première position aura de points</li>
					<li>3 points boni sont attribués si le joueur a participé au tournoi principal (ou aux qualifications)</li>
				</ul>

			</div>
			</div>
		);
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	handleSelectedStandingsChange(e) {
		var selectedStandings = e.target.value;
		this.setState({
			selectedStandings: selectedStandings,
		});
		this.buildTableData(selectedStandings);
	}

	// isNumeric function in javascript
	isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}
}

export default PredatorTour;
